import { connect } from 'react-redux';
import { compose, hoistStatics, withProps, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import Cover from './Cover';
import { getLoginCover } from '../../../helpers/auth.helper';
import dh from '../../../helpers/defaultImages.helper';

const mapStateToProps = state => ({
  coverLogin: state.settings.subscriber ? state.settings.subscriber.cover_login : '',
});

const enhance = compose(
  connect(mapStateToProps, null),
  withProps(props => ({
    cover: getLoginCover(props) || dh.defaultLogin,
  })),
  defaultProps({
    likeBackground: true,
  }),
  translate('portal'),
);

export default hoistStatics(enhance)(Cover);



// WEBPACK FOOTER //
// ./src/components/login/cover/index.js